'use client'

import { ComponentPropsWithRef } from 'react'

import { cn } from '@/shared/lib'

import { useCarousel } from './lib/use-carousel'

type Props = ComponentPropsWithRef<'button'> & {
  onClick?: (index: number) => void
  dotClassName?: string
}

export const DotButton = ({
  children,
  className,
  dotClassName,
  ...restProps
}: Props) => {
  const { orientation, scrollSnaps, selectedIndex, scrollTo } = useCarousel()

  const handleClick = (index: number) => () => {
    scrollTo(index)
  }

  return (
    <div
      className={cn(
        'absolute flex gap-1.5',
        {
          'bottom-2 left-1/2 -translate-x-1/2': orientation === 'horizontal',
          'top-1/2 right-2 -translate-y-1/2 flex-col':
            orientation === 'vertical',
        },
        className,
      )}
    >
      {scrollSnaps.map((_, index) => (
        <button
          key={index}
          type="button"
          className={cn(
            'h-1.5 w-1.5 cursor-pointer rounded-full bg-white',
            'focus-visible:ring-ring focus-visible:ring-3 focus-visible:outline-none',
            '[&[data-active=true]]:bg-black',
            dotClassName,
          )}
          onClick={handleClick(index)}
          data-active={index === selectedIndex}
          aria-label={`슬라이드 ${index + 1}(으)로 이동`}
          {...restProps}
        >
          {children}
        </button>
      ))}
    </div>
  )
}
